import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceGateAssessmentDetailPage = lazy(
  () => import("@/features/invoice-gate/pages/assessment-detail"),
);

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/$assessmentId")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading assessment...</div>}>
      <InvoiceGateAssessmentDetailPage />
    </Suspense>
  ),
});
